import { useCallback, useEffect } from 'react';
import DialogBoxComponent, { DialogBoxProps } from './DialogBox.component';

const DialogBox = ({
  isOpen,
  onCancelHandler,
  onConfirmHandler,
  ...props
}: DialogBoxProps): JSX.Element => {
  const closeDialogOnPressEscape = useCallback(
    (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        event.preventDefault();

        onCancelHandler();
      }
    },
    [onCancelHandler]
  );

  const onPageClick = useCallback(
    (event): void => {
      const doesElementContainId = (element): boolean => {
        return (
          element?.id?.includes('dialog-modal') ||
          element?.id?.includes('candidate-profile-picture-manager')
        );
      };
      const eventPath = event.composedPath() ?? [];

      const isClickingInsideDialog = eventPath.some(doesElementContainId);

      if (!isClickingInsideDialog) {
        onCancelHandler();
      }
    },
    [onCancelHandler]
  );

  useEffect(() => {
    if (!isOpen) {
      return () => {};
    }

    document.addEventListener('keydown', closeDialogOnPressEscape);
    window.addEventListener('click', onPageClick);

    return () => {
      window.removeEventListener('click', onPageClick);
      document.removeEventListener('keydown', closeDialogOnPressEscape);
    };
  }, [onPageClick, isOpen, closeDialogOnPressEscape]);

  return (
    <DialogBoxComponent
      isOpen={isOpen}
      onCancelHandler={onCancelHandler}
      onConfirmHandler={onConfirmHandler}
      {...props}
    />
  );
};

export default DialogBox;
